import { render, staticRenderFns } from "./ManageCnpjBulklogView.vue?vue&type=template&id=136e0e19"
import script from "./ManageCnpjBulklogView.vue?vue&type=script&lang=ts"
export * from "./ManageCnpjBulklogView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports